const rootForAuthenticationRoutes = "/users";

export const authRoutes = {
    register: (inviteCode: string) => `${rootForAuthenticationRoutes}/register/${inviteCode}`,
    signIn: `${rootForAuthenticationRoutes}/sign-in`,
    signOut: `${rootForAuthenticationRoutes}/sign-out`,
};
